import { render, staticRenderFns } from "./viewRequest.vue?vue&type=template&id=733bdd38"
import script from "./viewRequest.vue?vue&type=script&lang=js"
export * from "./viewRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports